<template>
    <div :class="shown ? 'show trash-container' : 'hide trash-container'">
        <h2><b>{{bold}}</b></h2>
        <battery :shown="type === 'battery'" />
        <pet :shown="type === 'pet'" />
        <can :shown="type === 'can'" />
        <tetrapack :shown="type === 'tetrapack'" />
    </div>
</template>

<script>
import Battery from '@/components/commercials/svgs/Battery';
import Pet from '@/components/commercials/svgs/Pet';
import Tetrapack from '@/components/commercials/svgs/Tetra';
import Can from '@/components/commercials/svgs/Can';

export default {
  components: {
    Battery, Pet, Tetrapack, Can
  },
  props: [
      "shown", "bold", "type"
  ],
  data () {
    return {
    }
  },
  mounted () {
  },
  created () {
  },
  computed: {
  },
  methods: {
      getSrc() {
          const src = `@/assets/img/icons/${this.type}.svg`;
          return src;
      }
  },
  watch: {
  }
}
</script>

<style scoped lang="scss">
  .hide {
    display: none
  }
</style>